// extracted by mini-css-extract-plugin
export default {"newPassInputs":"_1NyDt","passwordFormControl":"XhLq1","passwordInput":"_36pYi","infoText":"NeHq-","offerLink":"xAqSZ"};